import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { parseUrl } from '../helpers/core';
import AddUserForm from '../components/AddUserForm';
import Preloader from '../components/Preloader';
import { addUser, loadUserDetail, clearUserErrors } from '../actions/userActions';
import { SETTINGS } from '../constants/routes';

class UserDetailPage extends Component{
	componentWillMount () {
		const { id, loadUserDetail: load } = this.props;
		if (id) {
			load(id);
		}
	}

	render () {
		const { loading, user, id, addUser: add, initData, clearErrors, serverError } = this.props;

		if (loading && !user) {
			return <Preloader />
		}

		if (!id || !user) {
			return <div className="container">
				<h4>Некорректный адрес.</h4>
				<p>Рекомендуем перейти к <Link to={SETTINGS}>списку сотрудников</Link>.</p>
			</div>
		}

		return <div className="container">
			{
				loading ? <Preloader /> : null
			}
			<AddUserForm
				user={user}
				onSubmit={add}
				selectData={initData}
				clearErrors={clearErrors}
				serverError={serverError}
			/>
		</div>
	}
}

UserDetailPage.propTypes = {
	user: PropTypes.object,
	location: PropTypes.object,
	loadUserDetail: PropTypes.func.isRequired,
	addUser: PropTypes.func.isRequired,
	loading: PropTypes.bool,
	id: PropTypes.string,
	initData: PropTypes.object,
	clearErrors: PropTypes.func.isRequired,
	serverError: PropTypes.string
}

const mapStateToProps = (state, ownProps) => {
	const id = ownProps.location.search && parseUrl(ownProps.location.search).id;

	return {
		user: state.users.detail || null,
		loading: state.users.loading,
		id,
		initData: state.webInterface.initData,
		serverError: state.users.error,
		clients: state.clients.list
	}
}

const mapDispatchToProps = dispatch => ({
	loadUserDetail: id => dispatch(loadUserDetail(id)),
	addUser: data => dispatch(addUser(data)),
	clearErrors: () => dispatch(clearUserErrors())
});

export default connect(mapStateToProps, mapDispatchToProps)(UserDetailPage);



// WEBPACK FOOTER //
// ./containers/UserDetailPage.js